var e="@hpstellar/core/eco-label";export{e as ecoLabelTestId};
